/// <reference types="@angular/localize" />

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { enableProdMode, importProvidersFrom } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { provideAnimations } from "@angular/platform-browser/animations";
import { AppComponent } from "app/app.component";
import { setupChat } from "app/chat";
import { provideI18n } from "app/core";
import { COMPILATION_CONFIG } from "app/core/config/compilation-config.token";
import { HOST_SETUP } from "app/core/config/host-setup.token";
import { resolveInitEvent } from "app/core/events/init-event-resolver";
import { provideDimelo } from "app/dimelo";
import { provideLinkHandling } from "app/link";
import { UserHttpInterceptor } from "app/user";
import { environment } from "environments/environment";
import player from "lottie-web";
import { provideLottieOptions } from "ngx-lottie";

/* Check if the main component's element (bot-root) exists in the DOM
  Otherwise the whole angular bootstrap will fail
  the element is not found when Angular first tries to bootstrap
  inside the website's context then it works inside the iframe's context */
if (document.querySelector("bot-root")) {
  if (environment.production) {
    enableProdMode();
  } else {
    console.log("environment : ", environment);
  }

  resolveInitEvent().then((initResult) => {
    bootstrapApplication(AppComponent, {
      providers: [
        { provide: COMPILATION_CONFIG, useValue: initResult.compilationConfig },
        { provide: HOST_SETUP, useValue: initResult.hostSetup },
        importProvidersFrom(BrowserModule, FormsModule),
        { provide: HTTP_INTERCEPTORS, useClass: UserHttpInterceptor, multi: true },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        //
        provideI18n(),
        //
        provideDimelo(),
        provideLottieOptions({ player: () => player }),
        setupChat(),
        provideLinkHandling(),
      ],
    });
  });
}
